import { UserManager, WebStorageStateStore , User} from 'oidc-client-ts';

const client_id= "4b6dfc35-cacd-4949-8b26-fc80eca44b87"
const client_secret= "AMdnJ4w1bz_pUSjoH7ex-y8Sxi"
const userStoreMock = new WebStorageStateStore();

     const   mgr = new UserManager({
            authority: "https://core.api.aigw.eval.loginid.ai",
            client_id: client_id,
            client_secret: client_secret,
            redirect_uri: "https://aw.testnet.loginid.io/oauth2/callback",
            scope: "openid email profile",
            //client_authentication: "client_secret_basic",
            monitorSession : false,
            userStore: userStoreMock,
            /*
            metadata: {
                authorization_endpoint: "http://127.0.0.1:4444/oauth2/auth",
                end_session_endpoint:  "http://localhost:4444/oauth2/logout",
                token_endpoint: "http://localhost:4444/oauth2/token",
                revocation_endpoint: "http://localhost:4444/oauth2/revoke",
            },*/
        });

export class Oauth2Client {
    static async getUser() : Promise<User | null> {
        return await mgr.getUser()
    }
    static async auth() : Promise<User> {
       return await mgr.signinPopup({popupWindowFeatures:{width:480,height:480}}) 
    }
    static callback() {
        mgr.signinCallback()
    }
}